@if (!isFirst) {
  <hr />
}
<div><ng-content></ng-content></div>
